import moment from 'moment';
import type { VoidFunctionComponent } from 'react';

import { errorMessagesListFromResponse } from '../../../../helpers/errors';
import { useAsyncValue, useOnMount } from '../../../../hooks';
import { get } from '../../../../redux/api';
import { nuc } from '../../../../utils';
import Loader from '../../../generic/Loader';
import type { FailedFetchResponse } from '../../../../helpers/errors';

type Props = {
  // A revision or project locator for the issue dependency.
  locator: string;
};

/**
 * Displays issue details for Abandonware issues. Performs an async
 */
const AbandonwareDescription: VoidFunctionComponent<Props> = ({ locator }) => {
  const { value, errors, ...actions } = useAsyncValue<Date>(null);

  useOnMount(async () => {
    try {
      actions.setPending();
      const { data } = await get<Date>(`/api/projects/${nuc(locator)}/last-published`);
      actions.setResolve(data ?? null);
    } catch (error) {
      actions.setReject(errorMessagesListFromResponse(error as FailedFetchResponse));
    }
  });

  // The issue should only exist if this value is populated, so we know it exists.
  const lastDate = (value) ? moment(value).format('MMMM Do, YYYY') : <Loader size={16} style={{ display: 'inline' }} />;
  return (
    <>
      <div>This package has not received any updates in over two years.</div>
      { !errors && (
        <div>
          The last known update for this project was released{' '}
          <b>
            {lastDate}
          </b>
          .
        </div>
      )}
    </>
  );
};

export default AbandonwareDescription;
